import { Container, Stack } from "react-bootstrap";

export function Resume() {
  return (
    <>
    <Container>
      <h2>things I am doing:</h2>
      <Container>
        <Stack gap={3}>
          <h4>Platform / Site Reliability Engineer @ NAB</h4>
          <h4>Team Member of RMIT's <a href="https://redbackbots.com">RedbackBots</a> Robot Soccer Team</h4>
          <h4>Bachelor of Computer Science @ RMIT</h4>
        </Stack>
      </Container>
    </Container>

    <Container>
      <h2>things I have done:</h2>
      <Container>
        <Stack gap={3}>
          <h4>Bachelor of Psychological Science @ La Trobe</h4>
          <h4>2024/2025 Student Lead of RMIT's RedbackBots Robot Soccer Team</h4>
          <h4>Chair of 2024 RoboCup SPL Organising Committee</h4>
          <h4>Member of 2025 RoboCup SPL Technical Committee</h4>
        </Stack>
      </Container>
    </Container>
    </>
  );
}
